import { getRequestInterceptors } from "@faire/retailer-shared/web-api/getRequestInterceptors";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { getIsApparelRetailer } from "@faire/retailer-visitor-shared/serialized-data/getIsApparelRetailer";
import { CurrencyStore } from "@faire/web--source/common/currency/CurrencyStore";
import { clientSideLatencyRequestInterceptor } from "@faire/web--source/common/requests/request-interceptors/clientSideLatencyRequestInterceptor";
import { opentelemetryRequestInterceptor } from "@faire/web--source/common/requests/request-interceptors/opentelemetryRequestInterceptor";
import { darkReadsRequestInterceptor } from "@faire/retailer-visitor-shared/initialize/dark-read/darkReadsRequestInterceptor";
var interceptors = getRequestInterceptors({
    getIsApparelRetailer: function() {
        return !!getIsApparelRetailer();
    },
    getIsBrandPreview: function() {
        return getIsBrandPreview();
    },
    getSelectedCurrency: function() {
        return CurrencyStore.get().configuration.selectedCurrency;
    }
});
interceptors.push(darkReadsRequestInterceptor);
interceptors.push(opentelemetryRequestInterceptor);
interceptors.push(clientSideLatencyRequestInterceptor);
export var requestInterceptors = Object.freeze(interceptors);
